import { handleStoreState } from "../RESTStore/CoreStore";
import { observable, action, IObservableArray, runInAction, makeObservable } from "mobx";
import { API } from "General/API";
import { CoreDataStore } from "./CoreDataStore";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export abstract class ArrayDataStore<T extends { [key: string]: any }> extends CoreDataStore {
  data: IObservableArray<T> = [] as IObservableArray<T>;

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      clear: action,
      edit: action.bound,
      delete: action.bound,
      add: action,
      addOnTop: action,
      fetch: action,
    });
  }

  clear() {
    this.data = [] as IObservableArray<T>;
    this.state = "RAW";
    this.stateError = undefined;
  }

  @handleStoreState()
  async fetch(id?: string | number, queryParams?: object) {
    try {
      const response: T[] = await API.getData(this.url(id), queryParams);
      runInAction(() => {
        this.data = this.processResponse(response);
      });
    } catch (error) {
      this.processError(error);
      throw error;
    }
  }

  find(id: string | number, idField: keyof T) {
    return this.data.find((item) => item[idField] === id);
  }

  edit(id: string | number, newData: T, idField: keyof T = "id") {
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i] && this.data[i][idField] === id) {
        this.data[i] = newData;
        break; // Stop this loop, we found it!
      }
    }
  }

  delete(id: string | number, idField: keyof T = "id") {
    const index = this.data.findIndex((item) => item[idField] === id);
    if (index !== -1) {
      this.data.splice(index, 1);
    } else {
      throw new Error(`Item with "${String(idField)}: ${id}" not found`);
    }
  }

  add(newItem: T): void {
    this.data.push(this.processResponse(newItem));
  }

  addOnTop(newItem: T): void {
    this.data.unshift(this.processResponse(newItem));
  }
}
